import { render, staticRenderFns } from "./BeltSelect.vue?vue&type=template&id=237a1396&scoped=true"
import script from "./BeltSelect.vue?vue&type=script&lang=js"
export * from "./BeltSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237a1396",
  null
  
)

export default component.exports